import {
  loadModules
} from "esri-loader";
import apiService from "@/service/apiService";
import clonedeep from 'lodash.clonedeep';
import groupby from 'lodash.groupby';
import moment from 'moment';

export function getDistinctValues(targetFieldName, mapServiceUrlWithLayerNo, whereClause, isDesc, customOutFields) {
  return loadModules(["esri/tasks/QueryTask", "esri/tasks/support/Query"]).then((
    [QueryTask, Query]) => {

    var queryDistinctValuesTask = new QueryTask({
      url: mapServiceUrlWithLayerNo // URL of a feature layer representing U.S. states
    });

    var queryDistinctValues = new Query();
    queryDistinctValues.where = whereClause ? whereClause : "1=1";
    var outFields = [targetFieldName]
    if (customOutFields) {
      outFields = customOutFields
    }
    queryDistinctValues.outFields = outFields;
    queryDistinctValues.orderByFields = [targetFieldName + (isDesc ? " DESC" : " ASC")];
    queryDistinctValues.returnGeometry = false;
    queryDistinctValues.returnDistinctValues = true;

    return queryDistinctValuesTask
      .execute(queryDistinctValues)
      .then((distinctValueResults) => {

        var distinctValues = distinctValueResults.features.map(
           (f) => {
            if (outFields.length>1) {
              var outPutObject = {}
              outFields.forEach(outField => {
                outPutObject[outField] = f.attributes[outField]
              });
              return outPutObject;
            } else {
              return f.attributes[targetFieldName];
            }
          }
        );
        return distinctValues
      });

  });

}

export function generateLabelingInfo(options, scaleSetsAndFontSize) {
  var labelingInfo = [];
  scaleSetsAndFontSize.map(function (eachScaleSetAndFontSize) {

    var eachLabel = {
      labelExpression: options.labelExpression,
      labelPlacement: options.labelPlacement,
      symbol: clonedeep(options.symbol),
      minScale: eachScaleSetAndFontSize[0],
      maxScale: eachScaleSetAndFontSize[1],
    }
    eachLabel.symbol.font.size = eachScaleSetAndFontSize[2]
    labelingInfo.push(eachLabel)
  });
  return labelingInfo;
}
export function sqlProcess(Options, type, component){
  return function queryProvider(ctx, exportModeOption) {
    return loadModules(["esri/request", "esri/config"]).then(([esriRequest, esriConfig])=>{
      // console.log(document.URL);
      // if(document.URL.includes("localhost")){
      //   esriConfig.request.corsEnabledServers = ["localhost"];
      // }
      var resultOffset=0;
      var resultOffsetString = "";
      var resultRecordCountString = "";
      var orderByFieldsString = "";
      var getUrl = window.location;
      var url;
      if(getUrl.origin=="http://localhost:8080"){
        url = "https://egis-uat.hkairport.com/agl-fault-count-query/sqlProcess.aspx?"
      }else{
        url=getUrl.origin+"/agl-fault-count-query/sqlProcess.aspx?";
      }
      if(ctx){
        // &resultOffset=0&resultRecordCount=5
        resultOffset=(ctx.currentPage-1)*ctx.perPage;
        resultOffsetString = "&resultOffset="+resultOffset;
        resultRecordCountString ="&resultRecordCount="+ctx.perPage;
        orderByFieldsString = "&orderByFields="+(Options.orderBy?Options.orderBy:"");
      }
      else if(exportModeOption){
        resultOffsetString = "&resultOffset="+exportModeOption.start;
        resultRecordCountString ="&resultRecordCount="+exportModeOption.num;
        orderByFieldsString = "&orderByFields="+(exportModeOption.orderByFields?exportModeOption.orderByFields.join():"");
      }
      // function retrieve the previous Options while press next page or prev page button
      // in this case, to ensure the URL and Options are correct, the url must be separate from the Options but not passed from the caller
      // url = url+ Options + resultOffsetString + resultRecordCountString + orderByFieldsString;
      url = url+ Options.where + resultOffsetString + resultRecordCountString + orderByFieldsString;
      var sqlRequest = esriRequest(url, {
        responseType: "json"
      });

      return sqlRequest.then(function(response){
        // The requested data
        var resultJson = response.data;

        switch(type){
          case "agl":
          if(resultJson.data.hasOwnProperty("AGL")){
            var queryFeatureResultTransformed = resultJson.data.AGL.features.map(
              function (f) {
                //assign geometry inside attributes for use in datatable pan/edit
                f.attributes['_geometry'] = f.geometry
                return f.attributes
              }
            );
          }
          break;
          case "mags":
          if(resultJson.data.hasOwnProperty("MAGS")){
            var queryFeatureResultTransformed = resultJson.data.MAGS.features.map(
              function (f) {
                //assign geometry inside attributes for use in datatable pan/edit
                f.attributes['_geometry'] = f.geometry
                return f.attributes
              }
            );
          }
          break;
          case "ccr":
          if(resultJson.data.hasOwnProperty("CCR")){
            var queryFeatureResultTransformed = resultJson.data.CCR.features.map(
              function (f) {
                //assign geometry inside attributes for use in datatable pan/edit
                f.attributes['_geometry'] = f.geometry
                return f.attributes
              }
            );
          }
          break;
        }
        console.log("queryFeatureResultTransformed",queryFeatureResultTransformed);
        try {
          // to replace this.$parent.totalRows = recordCount; from generateQueryProvider

          switch(type){
            case "agl":
              component.$refs.aglDetailsTable.totalRows = resultJson.data.AGL.totalCount;
            break;
            case "mags":
              component.$refs.magsDetailsTable.totalRows = resultJson.data.MAGS.totalCount;
            break;
            case "ccr":
              component.$refs.ccrDetailsTable.totalRows = resultJson.data.CCR.totalCount;
            break;
          }
        } catch (e) {}
        return queryFeatureResultTransformed;
      }, function(e) {
        return [];
      });
    });
  }
}

export function sqlQueryProvider(Options, component, detailsTableName){
  return function queryProvider(ctx, exportModeOption) {
    return loadModules(["esri/request", "esri/config"]).then(([esriRequest, esriConfig])=>{
      var url;
      var getUrl = window.location;
      if(getUrl.origin=="http://localhost:8080"){
        url = "https://egis-uat.hkairport.com/agis-filter-by-map-query/FilterByMapQuery.aspx?"
      }else{
        url=getUrl.origin+"/agis-filter-by-map-query/FilterByMapQuery.aspx?";
      }
      var whereClauses;
      var extentWkt;
      var key;
      var orderBy;
      var perPage;
      var currentPage;
      var subQueryArray;
      if(Options){
        whereClauses = Options.whereClauses;
        extentWkt = Options.extentWkt;
        key = Options.key;
        orderBy = Options.orderBy;
        subQueryArray = Options.subQueryArray ? Options.subQueryArray: "";
      }
      if(ctx){ // ctx will save the Detailtable current page and page row // ctx.perPage // ctx.currentPage
        perPage = ctx.perPage;
        currentPage = ctx.currentPage;
        url+="where_clauses=" + encodeURIComponent(whereClauses)
        + "&polygon=" + extentWkt
        + "&web_config_key=" + key
        + "&order_by=" + orderBy
        + "&page_per_row=" + perPage
        + "&current_page=" + currentPage
        + "&sub_query_array=" + subQueryArray
      }
      else if(exportModeOption){
        url+="where_clauses=" + encodeURIComponent(whereClauses)
        + "&polygon=" + extentWkt
        + "&web_config_key=" + key
        + "&order_by=" + orderBy
        + "&page_per_row=" + exportModeOption.perPage
        + "&current_page=" + exportModeOption.currentPage
        + "&sub_query_array=" + subQueryArray
        // + "&page_per_row=" + perPage
        // + "&current_page=" + currentPage
      }
      // console.log(url);
      // else if(exportModeOption){
      //   resultOffsetString = "&resultOffset="+exportModeOption.start;
      //   resultRecordCountString ="&resultRecordCount="+exportModeOption.num;
      //   orderByFieldsString = "&orderByFields="+(exportModeOption.orderByFields?exportModeOption.orderByFields.join():"");
      // }

      var sqlRequest = esriRequest(url, {
        responseType: "json"
      });

      return sqlRequest.then(function(response){
        try {
          // The requested data
          // console.log("FilterByMapResponse",response)
          var resultJson = response.data;
          var queryFeatureResultTransformed = resultJson.features.map(
            function (f) {
              //assign geometry inside attributes for use in datatable pan/edit
              f.attributes['_geometry'] = f.geometry
              return f.attributes
            }
          );
          // console.log(component);
          // console.log("detailsTableName",component.$refs[detailsTableName]);
          component.$refs[detailsTableName].totalRows = resultJson.totalCount;
          // console.log("queryFeatureResultTransformed",queryFeatureResultTransformed);
        } catch (e) {console.log(e)} // do nothing if ex catched.
        return queryFeatureResultTransformed;
      }, function(e) {
        return [];
      });
    });
  }
}

export function generateQueryProvider(mapServiceUrlWithLayerNo, queryOptions) {
  return function queryProvider(ctx, exportModeOptions) {

    return loadModules(["esri/tasks/QueryTask", "esri/tasks/support/Query"]).then((
      [QueryTask, Query]) => {

      //this == the table component. DetailsTable is its parent. this.$parent
      var queryFeatureTask = new QueryTask({
        url: mapServiceUrlWithLayerNo // URL of a feature layer representing U.S. states
      });

      var requestOption = {
        cacheBust:true
      }

      var queryFeature = new Query();
      // queryFeature.where = `CORE_LOCATION = '${coreLocation}'`;
      queryFeature.outFields = ["*"];

      // queryFeature.orderByFields = ["YEAR_REF ASC"];
      queryFeature.num = this.perPage;
      queryFeature.start = (this.currentPage - 1) * this.perPage;

      //for export table, need to override num and start setting.
      if (exportModeOptions && exportModeOptions.num > -1 && exportModeOptions.start > -1) {
        queryFeature.num = exportModeOptions.num;
        queryFeature.start = exportModeOptions.start;
      }

      //filter by where clause
      if (queryOptions && queryOptions.where) {
        queryFeature.where = queryOptions.where
      }

      //group by fields and out statistics supported
      if (queryOptions && queryOptions.groupByFieldsForStatistics && queryOptions.outStatistics) {
        queryFeature.groupByFieldsForStatistics = queryOptions.groupByFieldsForStatistics
        queryFeature.outStatistics = queryOptions.outStatistics

      }

      //filter by map extent
      if (queryOptions && queryOptions.geometry) {
        queryFeature.spatialRelationship = "intersects"
        queryFeature.geometry = queryOptions.geometry
      }

      //order by specified fields

      if (exportModeOptions && exportModeOptions.orderByFields) {
        queryFeature.orderByFields = exportModeOptions.orderByFields //user export override order by
      } else if (this.$parent && this.$parent.orderByFields && this.$parent.orderByFields.length > 0) { //user override order by
        queryFeature.orderByFields = this.$parent.orderByFields;
      } else if (queryOptions && queryOptions.orderByFields) { //default order by
        queryFeature.orderByFields = queryOptions.orderByFields
      }

      //returnGeometry or not. Must set as true for orderBy SHAPE.STArea()
      //or orderBy SHAPE.STLength() to work

      if (queryOptions && queryOptions.returnGeometry) {
        queryFeature.returnGeometry = queryOptions.returnGeometry
      }

      //for execute for count, need to remove start and num and order by fields parameters to prevent query failure if the map service layer's source table is not registered
      var queryFeatureCloneForCount = queryFeature.clone();
      queryFeatureCloneForCount.start = null;
      queryFeatureCloneForCount.num = null;
      queryFeatureCloneForCount.orderByFields = null;
      queryFeatureCloneForCount.where = queryFeature.where ? queryFeature.where : "1=1";
      queryFeatureTask.executeForCount(queryFeatureCloneForCount, requestOption).then((recordCount) => {

        //this == the table component. DetailsTable is its parent. this.$parent
        this.$parent.totalRows = recordCount;
      });

      return queryFeatureTask
        .execute(queryFeature, requestOption)
        .then((queryFeatureResult) => {

          var queryFeatureResultTransformed = queryFeatureResult.features.map(
            function (f) {
              //assign geometry inside attributes for use in datatable pan/edit
              f.attributes['_geometry'] = f.geometry
              return f.attributes
            }
          );

          if (queryOptions.callbackAfterTransformed) {
            queryOptions.callbackAfterTransformed(queryFeatureResultTransformed);
          }

          return queryFeatureResultTransformed
        });

    });
  }
}


export function queryLayerInfo(mapServiceUrlWithLayerNo) {
  return loadModules(["esri/request"])
    .then(([esriRequest]) => {

      var url = mapServiceUrlWithLayerNo + "?f=json";

      return esriRequest(url, {
        responseType: "json"
      }).then(function (layerInfo) {
        // The requested data

        return layerInfo.data
      });
    });
}

export function exportMapFromServer(mapServiceUrl, params) {
  return loadModules(["esri/request"])
    .then(([esriRequest]) => {

      var url = mapServiceUrl + "/export";

      return esriRequest(url, {
        responseType: "json",
        method: 'post',
        body: params
      }).then(function (exportMapResult) {
        // The requested data
        return exportMapResult.data.href
      });
    });
}

export function exportMapFromServerForExtentAndImageUrl(mapServiceUrl, params) {
  return loadModules(["esri/request"])
    .then(([esriRequest]) => {

      var url = mapServiceUrl + "/export";

      return esriRequest(url, {
        responseType: "json",
        method: 'post',
        body: params
      }).then(function (exportMapResult) {
        // The requested data
        return exportMapResult.data
      });
    });
}

export function getLegend(mapServiceUrl, params, layerInfo) {

  function buildLegendSubLayerItemTitleMappings(layerInfo) {
    var mappings = {}

    //only get legend of visible sublayers
    var visibleSubLayers = layerInfo.sublayers.filter((eachSubLayer) => {
      return eachSubLayer.visible
    });
    visibleSubLayers = visibleSubLayers.filter((eachSubLayer) => {
      return eachSubLayer.legendEnabled
    });
    visibleSubLayers.items.map((eachItem) => {
      mappings[eachItem.id] = eachItem.title;
    });
    return mappings;
  }
  return loadModules(["esri/request"])
    .then(([esriRequest]) => {
      var url = mapServiceUrl + "/legend";

      var legendSubLayerItemTitleMappings = buildLegendSubLayerItemTitleMappings(layerInfo);
      return esriRequest(url, {
        responseType: "json",
        method: 'post',
        body: params,
        timeout: 600000
      }).then(function (getLegendResult) {
        // The requested data
        var getLegendResultMapped = getLegendResult.data.layers.map((eachLayer) => {
          eachLayer.layerName = legendSubLayerItemTitleMappings[eachLayer.layerId];
          return eachLayer;
        });
        return getLegendResultMapped;
      });
    });
}


export function generatePortalUserQueryProvider(queryOptions) {
  //console.log(apiService);
  return function queryProvider(ctx, exportModeOptions) {
    //console.log(apiService);
    var a = new apiService()
    return loadModules(["esri/request"])
      .then(([esriRequest]) => {

        var url = process.env.__PORTAL_URL__ + "/sharing/rest/community/users"

        var queryObj = {
          responseType: "json",
          query: {
            f: 'pjson',
            q: '0123456789ABCDEF',
            sortField: 'username',
            sortOrder: '',
            num: this.perPage,
            start: (this.currentPage - 1) * this.perPage + 1
          }
        };

        //for filtering
        if (queryOptions && queryOptions.q) {
          queryObj.query.q = queryOptions.q;
        }

        //for csv download
        if ((exportModeOptions.queryFor && exportModeOptions.queryFor == 'download')) {
          queryObj.query.num = exportModeOptions.num;
          queryObj.query.start = exportModeOptions.start
        }

        return esriRequest(url, queryObj).then((result) => {

          // The requested data
          var userResultSet = result.data;
          this.$parent.totalRows = userResultSet.total;

          //query users system levels by username

          var users = userResultSet.results;

          var userNames = users.map((eachUser) => {
            return eachUser.username
          })

          return a.getUserSystemLevelsByUserName(userNames).then((results) => {
            var flattenResults;

            if (exportModeOptions.queryFor && exportModeOptions.queryFor == 'download') {
              flattenResults = results.data.map((r) => {
                var fullName = users.find((eachUser) => {
                  return r.user_name == eachUser.username
                }).fullName;
                return {
                  user_name: r.user_name,
                  user_full_name: fullName,
                  user_system_levels: r.user_system_levels.map((eachSystemLevel) => {
                    return eachSystemLevel.name + ":" + eachSystemLevel.level
                  }).join('|')
                }
              })
            } else {
              flattenResults = results.data.map((r) => {
                var fullName = users.find((eachUser) => {
                  return r.user_name == eachUser.username
                }).fullName;
                return {
                  user_name: r.user_name,
                  user_full_name: fullName,
                  user_system_levels: r.user_system_levels,
                  user_system_levels_for_display: r.user_system_levels.map((eachSystemLevel) => {
                    return eachSystemLevel.name + " " + eachSystemLevel.level
                  }).join('<br>')
                }
              })
            }


            return flattenResults;
          });

          //  users = users.map((eachUser)=>{
          //      return {
          //          username: eachUser.username,
          //          fullName: eachUser.fullName,
          //          systems:[]
          //      }
          //  });
          //  return users;
        });
      });
  }
}


export function getAlignments() {
  var ALIGNMENT_LAYER_URL = process.env.__MAP_SERVER_URLS__.PAVEMENT_ALIGNMENT + "/1";
  return loadModules(["esri/tasks/QueryTask", "esri/tasks/support/Query"]).then((
    [QueryTask, Query]) => {

    var queryTask = new QueryTask({
      url: ALIGNMENT_LAYER_URL // URL of a feature layer representing U.S. states
    });

    var query = new Query();
    query.where = "1=1";
    query.outFields = ["*"];
    query.orderByFields = ["NAME", "CHAINAGE_START"];
    query.returnGeometry = true;
    query.returnDistinctValues = false;

    return queryTask
      .execute(query)
      .then((alignmentResults) => {



        var alignmentResultsFeatures = alignmentResults.features.map(
          function (f) {
            return f.attributes
          }
        );
        var alignmentResultsFeaturesGroupByName = groupby(alignmentResultsFeatures, 'NAME')
        var alignments = [];

        for (var eachAlignmentName in alignmentResultsFeaturesGroupByName) {
          var alignmentsSegments = alignmentResultsFeaturesGroupByName[eachAlignmentName]
          var CHAINAGE_STARTs = alignmentsSegments.map((eachAlignmentSegment) => eachAlignmentSegment.CHAINAGE_START)
          var CHAINAGE_ENDs = alignmentsSegments.map((eachAlignmentSegment) => eachAlignmentSegment.CHAINAGE_END)

          var min_CHAINAGE_START = Math.min(...CHAINAGE_STARTs);
          var max_CHAINAGE_END = Math.max(...CHAINAGE_ENDs);

          alignments.push({
            NAME: eachAlignmentName,
            CHAINAGE_START: min_CHAINAGE_START,
            CHAINAGE_END: max_CHAINAGE_END
          })
        }

        return {
          alignments: alignments,
          alignmentsSegments: alignmentResultsFeaturesGroupByName
        }


      });

  });
}

export function getCustomizeContracts() {
  var RESURFACING_CONTRACT_LAYER_URL = process.env.__MAP_SERVER_URLS__.RESURFACING + "/3";
  return loadModules(["esri/tasks/QueryTask", "esri/tasks/support/Query"]).then((
    [QueryTask, Query]) => {

    var queryTask = new QueryTask({
      url: RESURFACING_CONTRACT_LAYER_URL // URL of a feature layer representing U.S. states
    });

    var query = new Query();
    query.where = "1=1";
    query.outFields = ["*"];
    query.orderByFields = ["ACTIVE", "ORDERING"];
    query.returnGeometry = false;
    query.returnDistinctValues = false;

    return queryTask
      .execute(query)
      .then((contractResults) => {



        var contractResultsFeatures = contractResults.features.map(
          function (f) {
            return f.attributes
          }
        );

        var contractResultsFeaturesTransformed = contractResultsFeatures.map((eachContract) => {
          return {
            contractRef: eachContract['CONTRACT_REF'],
            ordering: parseInt(eachContract['ORDERING']),
            isActive: (eachContract['ACTIVE'] == 1),
            colorHex: eachContract['COLOR']
          }
        });

        return contractResultsFeaturesTransformed;
      });

  });
  //mock api return sample data
  // this.contracts = [
  //     {
  //         contractRef:'M635',
  //         ordering:1,
  //         isActive:false,
  //         colorHex:'#ff0000',
  //     },
  //     {
  //         contractRef:'M636',
  //         ordering:2,
  //         isActive:true,
  //         colorHex:'#00ff00',
  //     },
  //     {
  //         contractRef:'M637',
  //         ordering:3,
  //         isActive:false,
  //         colorHex:'#0000ff',
  //     },
  // ]
}

export function uploadFileForGP(uploadUrl, fileObj, fileName) {
  return loadModules(["esri/request"])
    .then(([esriRequest]) => {

      var url = uploadUrl;
      //https://egis-uat.hkairport.com/arcgis/sdk/rest/index.html#/Upload/02ss0000000m000000/
      var formData = new FormData();
      if (fileName) {
        formData.append("file", fileObj, fileName); //must set as file, see above doc
      } else {
        formData.append("file", fileObj); //must set as file, see above doc
      }
      formData.append("f", "json"); //must set as f and json, see above doc

      return esriRequest(url, {
        responseType: "json",
        method: 'post',
        body: formData
      }).then(function (uploadFileResult) {
        // The requested data
        return uploadFileResult.data
      });
    });
}
export function customFormatterForLogDate(date) {
  //e.g 7/23/12 == 2012-07-23 => unix timestamp
  //e.g 12/2/12 == 2012-12-02 => unix timestamp
  return moment(date, "M/D/YY").valueOf();
}

export function applyEditRequest(FS_URL, addJSON, updateJSON, deleteJSON, responseHandler, errorHandler) {
  return loadModules(["esri/request"]).then(([esriRequest]) => {
    return esriRequest(FS_URL + "/applyEdits", {
      responseType: "json",
      method: 'post',
      body: {
        adds: addJSON,
        updates: updateJSON,
        deletes: deleteJSON,
        f: "pjson"
      }
    }).then((response) => {
      var failedResult = {
        adds: [],
        updates: [],
        deletes: []
      };
      var handleResult = function (resultArr) {
        var outputArr = [];
        resultArr.forEach((result) => {
          if (!result.success) {
            if (result.objectId) {
              outputArr.push(result.objectId);
            } else {
              outputArr.push(-1);
            }
          }
        });
        return outputArr;
      }
      failedResult.adds = handleResult(response.data.addResults);
      failedResult.updates = handleResult(response.data.updateResults);
      failedResult.deletes = handleResult(response.data.deleteResults);
      if (failedResult.adds.length > 0 ||
        failedResult.updates.length > 0 ||
        failedResult.deletes.length > 0
      ) {
        if (errorHandler) {
          //   var errorMsg = "Edit failed. Please contact administrator."
          //   alert(errorMsg);
          response.failedResult = failedResult
          errorHandler(response);
        } else {
          var errorMsg = "Edit failed. Please contact administrator."
          alert(errorMsg);
        }
        return false;
      } else {
        if (responseHandler) {
          // this.isUpdating = false;
          // this.$refs.editModalRef.hide();
          // this.clearEditing();
          responseHandler(response);
        } else {
          alert("Update Completed.");
        }
        return true;
      }
    });

  });
}


export function applyLogRequest(FS_LOG_URL, addJSON) {
  return loadModules(["esri/request"]).then(([esriRequest]) => {
    return esriRequest(FS_LOG_URL + "/addFeatures", {
      responseType: "json",
      method: 'post',
      body: {
        features: addJSON,
        f: "pjson"
      }
    }).then((response) => {
      console.log(response);
      // var failedResult = {
      //   adds: [],
      //   updates: [],
      //   deletes: []
      // };
      // var handleResult = function (resultArr) {
      //   var outputArr = [];
      //   resultArr.forEach((result) => {
      //     if (!result.success) {
      //       if (result.objectId) {
      //         outputArr.push(result.objectId);
      //       } else {
      //         outputArr.push(-1);
      //       }
      //     }
      //   });
      //   return outputArr;
      // }
      // failedResult.adds = handleResult(response.data.addResults);
      // failedResult.updates = handleResult(response.data.updateResults);
      // failedResult.deletes = handleResult(response.data.deleteResults);
      // if (failedResult.adds.length > 0 ||
      //   failedResult.updates.length > 0 ||
      //   failedResult.deletes.length > 0
      // ) {
      //   console.log("add Audit Log Fail.");
      //   return false;
      // } else {
      //   console.log("add Audit Log Success.");
      //   return true;
      // }
    });

  });
}



// WEBPACK FOOTER //
// ./src/service/restAPIHelper.js